enum CardType {
    List = 'lst',
    Widget = 'wdg',
    Graphic = 'gph',
    Planning = 'pln',
    Scheduler = 'sch'
}

export default CardType;